import { BoardAddSection } from './subcomponents/BoardAddSection';
import { BoardSection } from './subcomponents/BoardSections';
import { boardServices } from 'src/services';
import { H2, Loading } from 'src/components/_commons';
import { setAlertResponse } from 'src/store';
import { typeBoardSection } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

export const AdminsBoard = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [sections, setSections] = useState<typeBoardSection[] | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        boardServices.Get().then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.board) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setSections(response.data.board.sections);
        });
    }, [refreshCounter]);

    return (
        <>
        <H2 title={'ADMINISTRACIÓN TABLERO'} />
        {isLoading &&
            <Loading />
        }
        <div>
            {sections?.sort((s1, s2) => s1.order - s2.order).map(section =>
                <BoardSection key={section.title}
                    section={section}
                    sections={sections}
                    setRefreshCounter={setRefreshCounter}
                />
            )}
        </div>
        {!isLoading &&
            <BoardAddSection
                sections={sections}
                setRefreshCounter={setRefreshCounter}
            />
        }
        </>
    );
}
